/* eslint-disable max-len */
/* eslint-disable */
import { useEffect, useState } from 'react';
// import moment from 'moment';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';
import { Button, Chip } from '@mui/material';
import { connect } from 'react-redux';
import ImagesFinder from '../../Components/ImagesFinder/ImagesFinder';
import styles from './VendorOpening.module.scss';
import { ListTable } from '../../Components/ListTable';
// import allVendorServices from '../../Services/Form Services/allvendor.services';
import { BackdropLoader } from '../../Components/Loaders';
import { urls } from '../../Constants';
import inventoryAnalyticsServices from '../../Services/Analytics Services/inventory-analytics.services';
import { addCommas, classes, filtersInfoChip, handleExportData } from '../../Helpers';
import { modalActions } from '../../Actions';
import { notificationServices } from '../../Services';
import { useAuth } from '@/Components/Auth/Login/auth';
import authActions from '@/Actions/auth.actions';
import { Filter } from 'lucide-react';
import drawerActions from '@/Actions/drawer.actions';

const TABLE_COLUMNS = [
	{
		title: 'Vendor Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Bill Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Status',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Opening Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Opening Amount',
		config: {
			type: 'DATA',
		},
	},
];

const SPECIAL_COLUMNS = [
	{
		title: 'Actions',
		config: {
			type: 'DATA',
		},
	},
];


const COLMAP = {
	'Vendor Name': 'vendorName',
	'Bill Type': 'subType',
	Status: 'transactionStatus',
	'Opening Date': 'createdAt',
	'Opening Amount': 'finalTransactionAmount',
};

const FIND_FILTERS = ['vendor'];

const VendorOpening = (props) => {
	const { toggleAlert , toggleFiltersDrawer} = props;
	const history = useHistory();
	const [vendorOpenings, setVendorOpenings] = useState([]);
	const [loading, setLoading] = useState(false);
	const [update, setUpdate] = useState(-1);
	const [filters, setFilters] = useState({});
	const { userConfig } = useAuth();
	const { level } = userConfig?.userDetails || {};

	const handleCancelBill = async (item) => {
		setLoading(true);
		try {
			const responseData =
				await inventoryAnalyticsServices.updateInventoryTransaction({
					params: {
						transactionId: item?.id,
					},
					data: {
						status: 'CANCELLED',
						type: 'BILL',
					},
				});
			if (responseData?.statusCode === 200) {
				setUpdate((prev) => {
					return prev + 1;
				});
				notificationServices?.generateNotification({
					type: 'success',
					message: responseData?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	const SPECIAL_ITEMS = {
		'Bill Type': (type) => {
			return (
				<div className={classes(styles.type, styles?.[type])}>
					{type}
				</div>
			);
		},
		'Opening Date': (openingDate) => {
			return moment(openingDate)?.format('YYYY-MM-DD');
		},
		'Opening Amount': (openingAmount) => {
			return `\u20B9${addCommas(openingAmount)}`;
		},
		Actions: (id) => {
			const item = vendorOpenings?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div>
					{item?.transactionStatus !== 'CANCELLED' && (
						<Button
							onClick={() => {
								toggleAlert(true, {
									heading: 'Cancel Vendor Opening?',
									handleConfirm: () => {
										handleCancelBill(item);
										toggleAlert(false);
									},
									colorReverse: false,
									cancelText: 'No',
									confirmText: 'Yes',
									message: `Are you sure you want to Cancel Vendor Opening: ${
										item?.clientTransactionId || ''
									} of Vendor: ${item?.vendorName}?`,
									width: '28rem',
								});
							}}
							variant='outlined'
							color='error'
							fullWidth
						>
							Cancel
						</Button>
					)}
				</div>
			);
		},
	};

	const handleListFetch = async (requestOptions) => {
		setLoading(true);
		setFilters(requestOptions);
		try {
			const responseData =
				await inventoryAnalyticsServices.fetchInvTransRecord({
					req: {
						data: {
							filters: {
								vendors: requestOptions?.vendors?.id,
								isOpeningBalance: true,
							},
							type: 'BILL',
						},
					},
				});
			if (responseData?.statusCode === 200) {
				setVendorOpenings(responseData?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setLoading(false);
		}
	};
	const handleAddClick = () => {
		history.push(`${urls.EXTENSION}${urls.VENDOR_OPENING}/add`);
	};

	const filtersInfo = {
		header:{
			store: false,
		},
		vendor : {
			show: true,
			text: 'Vendor',
		},
	};
	const exportInfo = {
		showExportBtn : true,
	};
	return (
		<div className={styles.root}>
			<BackdropLoader showProgress isLoading={loading} />
			<div className={styles.filter}>
				<ImagesFinder
					FILTERS={FIND_FILTERS}
					onSubmit={handleListFetch}
					update={update}
					filtersInfo={filtersInfo}
					exportInfo={exportInfo}
				/>
				<div className='flex justify-between m-4 '>
					<span className='font-bold text-[16px]'>Vendor Opening</span>
					<div className='flex gap-2'>
					<Button
						onClick={() => {
							toggleFiltersDrawer(true, {
								exportFrontend : true,
								handleExportFrontend : () => handleExportData(vendorOpenings, COLMAP, 'VendorOpening'),
							});
						}}
						className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
					>
						<span className='flex items-center gap-2 text-nowrap capitalize'>Filter & Export</span>
						<Filter className='size-4' />
					</Button>
					{level !== 1 && (
					<Button
						onClick={handleAddClick}
						className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
					>
						+ Add Vendor Opening
						</Button>
					)}
					</div>
				</div>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<div className={styles.listing}>
				<ListTable
					colMap={COLMAP}
					columns={TABLE_COLUMNS}
					data={vendorOpenings?.map((ele) => {
						return {
							...ele,
							rowStyles: classes(styles.row, styles?.[ele?.transactionStatus]),
						};
					})}
					showTotal
					// data={dummyData}
					actions={level !== 1 ? [...SPECIAL_COLUMNS] : []}
					special={SPECIAL_ITEMS}
					showBtnContainer={false}
				/>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { userPermissions, navState } = state.navigation;
	const { userList } = state?.auth;
	return {
		userPermissions,
		navState,
		userList,
	};
};

const mapDispatchToProps = {
	toggleAlert: modalActions.toggleAlert,
	fetchUserList: authActions.fetchUserList,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(VendorOpening);
